module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topbar-setting"
  }, [_c('div', {
    directives: [{
      name: "Clickoutside",
      rawName: "v-Clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    staticClass: "topbar-setting-button fs-16",
    on: {
      "click": _vm.handleOpen
    }
  }, [_c('el-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    staticStyle: {
      "width": "200px",
      "margin-right": "5px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "输入并选择水司",
      "hide-loading": true
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.state4),
      callback: function($$v) {
        _vm.state4 = $$v
      },
      expression: "state4"
    }
  }), _c('span', {
    staticClass: "topbar-setting-username d-lg-inline"
  }, [_vm._v(_vm._s(_vm.realName) + _vm._s(_vm.customerId))]), _vm._m(0)], 1), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right profile-dropdown",
    class: {
      'd-block': _vm.isActive
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": "/setting/changePassword"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-lock"
  }), _vm._v(" 修改密码")]), _c('a', {
    staticClass: "dropdown-item clearfix bg-master-lighter",
    on: {
      "click": _vm.logout
    }
  }, [_c('span', {
    staticClass: "float-left"
  }, [_vm._v("退出")]), _vm._m(1)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "topbar-setting-img thumbnail-wrapper d32 circular inline"
  }, [_c('img', {
    attrs: {
      "src": require("./setting-account.jpg"),
      "width": "32",
      "height": "32"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "float-right"
  }, [_c('i', {
    staticClass: "iconfont icon-power-off"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19055e72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/Topbar/Setting.vue
// module id = 1706
// module chunks = 1